/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import MandantBelegBreadcrumb from "../Components/MandantBelegBreadcrumb";
import MandantBelegeBreadcrumb from "../Components/MandantBelegeBreadcrumb";
import MandantBelegProvisionenBreadcrumb from "../Components/MandantBelegProvisionenBreadcrumb";
import MandantBelegDetailsView from "../Views/MandantBelegDetailsView";
import MandantBelegeNavigationView from "../Views/MandantBelegeNavigationView";
import MandantBelegeView from "../Views/MandantBelegeView";
import MandantBelegProvisionenView from "../Views/MandantBelegProvisionenView";
import MandantBelegView from "../Views/MandantBelegView";
import TestzugangRedirect from "../Views/TestzugangRedirect";
import AppRouterDefinition from "./../../../AppRouterDefinition";
import VerticalSplit from "./../../../Basis/Components/VerticalSplit";

const BestaetigeEMailDialog = React.lazy(() => import(/* webpackChunkName: "Mandanten" */"../Views/BestaetigeEMailDialog"));
const BestaetigeEMailAenderungDialog = React.lazy(() => import(/* webpackChunkName: "Mandanten" */"../Views/BestaetigeEMailAenderungDialog"));
const MandantView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */"../Views/MandantView"));
const SupportMandantenView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/SupportMandantenView"));
const MandantBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "./../Components/MandantBreadcrumb"));
const SupportMandantBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "./../Components/SupportMandantBreadcrumb"));
const SupportMandantenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "./../Components/SupportMandantenBreadcrumb"));
const SupportMandantView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/SupportMandantView"));
const SupportMandantenNavigationView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/SupportMandantenNavigationView"));
const SupportMandantDetailsView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/SupportMandantDetailsView"));
const SupportMandantFirmendatenView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/SupportMandantFirmendatenView"));
const SupportMandantFirmendatenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Components/SupportMandantFirmendatenBreadcrumb"));
const SupportMandantProvisionsdatenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Components/SupportMandantProvisionsdatenBreadcrumb"));
const SupportMandantDatenschutzeinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Components/SupportMandantDatenschutzeinstellungenBreadcrumb"));
const SupportMandantKontenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Components/SupportMandantKontenBreadcrumb"));
const SupportMandantProvisionsdatenView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/SupportMandantProvisionsdatenView"));
const SupportMandantDatenschutzeinstellungenView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/SupportMandantDatenschutzeinstellungenView"));
const MandantFirmendatenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Components/MandantFirmendatenBreadcrumb"));
const MandantAbgleichDetailsBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Components/MandantAbgleichDetailsBreadcrumb"));
const FinanzeinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Components/FinanzeinstellungenBreadcrumb"));
const SupportKontoMandantenView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/SupportKontoMandantenView"));
const MandantDetailsView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/MandantDetailsView"));
const FirmendatenDetailsView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/FirmendatenDetailsView"));
const MandantAbgleichDetailsView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/MandantAbgleichDetailsView"));
const FinanzeinstellungenView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/FinanzeinstellungenView"));
const FinanzeinstellungenDetailsView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/FinanzeinstellungenDetailsView"));
const KontoAdressenDetailsView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../../../Cloud/Buchungsportal/Views/KontoAdressenDetailsView"));
const KontoAdresseBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "./../Components/KontoAdresseBreadcrumb"));
const TeamsKontenView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/TeamsKontenView"));
const TeamsKontenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Components/TeamsKontenBreadcrumb"));
const ZoomNutzerView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/ZoomNutzerView"));
const ZoomNutzerBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Components/ZoomNutzerBreadcrumb"));
const ZoomAccountDetailsView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/ZoomAccountDetailsView"));
const ZoomAccountBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Components/ZoomAccountBreadcrumb"));
const ZoomAccountsNavigationView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/ZoomAccountsNavigationView"));
const NutzendeBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "./../Components/NutzendeBreadcrumb"));
const NutzendeView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/NutzendeView"));
const SupportRedirect = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../../Support/Views/SupportRedirect"));
const AgbRedirect = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/AgbRedirect"));
const DatenschutzRedirect = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../Views/DatenschutzRedirect"));
const MitteilungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../../Mitteilungen/Components/MitteilungenBreadcrumb"));
const MitteilungenView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */ "../../Mitteilungen/Views/MitteilungenView"));
const DigitalerAushangView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */"../Views/DigitalerAushangView"));
const VerbesserungsvorschlaegeView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */"../Views/VerbesserungsvorschlaegeView"));
const VerbesserungsvorschlaegeBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */"../Components/VerbesserungsvorschlaegeBreadcrumb"));
const RoadmapBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mandanten" */"../Components/RoadmapBreadcrumb"));
const RoadmapView = React.lazy(() => import(/* webpackChunkName: "Mandanten" */"../Views/RoadmapView"));

const TEAMSPATH = "/integration/teams";
export const ZOOMPATH = "/integration/zoom";
const FINANZEINSTELLUNGENPATH = "/finanzeinstellungen";
const NUTZENDEPATH = "/nutzende";
const MANDANTPATH = "/mandant";
const SUPPORTMANDANTPATH = "/supportmandant/:mandantId";

export const mandantenRouterDefintions: Array<AppRouterDefinition> = [
    {
        path: TEAMSPATH,
        render: (renderProps: any) => <TeamsKontenView {...renderProps} />,
        createBreadcrumbs: () => [<TeamsKontenBreadcrumb />]
    },
    {
        exact: true,
        path: ZOOMPATH,
        render: (renderProps: any) => <ZoomNutzerView {...renderProps} />,
        createBreadcrumbs: () => [<ZoomNutzerBreadcrumb />]
    },
    {
        exact: true,
        path: `${ZOOMPATH}/account/:zoomAccountId`,
        render: (renderProps: any) => <VerticalSplit
            left={() => <ZoomAccountsNavigationView {...renderProps} />}
            right={() => <ZoomAccountDetailsView {...renderProps} />}
        />,
        createBreadcrumbs: (props: any) => [
            <ZoomNutzerBreadcrumb />,
            <ZoomAccountBreadcrumb zoomAccountId={props.zoomAccountId} />
        ]
    },
    {
        path: "/verbesserungsvorschlaege",
        render: (renderProps: any) => <VerbesserungsvorschlaegeView />,
        createBreadcrumbs: () => [<VerbesserungsvorschlaegeBreadcrumb />],
    },
    {
        path: "/roadmap",
        render: (renderProps: any) => <RoadmapView />,
        createBreadcrumbs: () => [<RoadmapBreadcrumb />],
    },
    {
        path: NUTZENDEPATH,
        render: (renderProps: any) => <NutzendeView {...renderProps} />,
        createBreadcrumbs: () => [<NutzendeBreadcrumb />],
    },
    {
        path: FINANZEINSTELLUNGENPATH,
        render: (renderProps: any) => <FinanzeinstellungenView {...renderProps} />,
        createBreadcrumbs: () => [<FinanzeinstellungenBreadcrumb />],
    },
    {
        exact: true,
        path: FINANZEINSTELLUNGENPATH,
        parentPath: FINANZEINSTELLUNGENPATH,
        render: (renderProps: any) => <FinanzeinstellungenDetailsView {...renderProps} />,
        createBreadcrumbs: () => [<FinanzeinstellungenBreadcrumb />],
    },
    {
        path: MANDANTPATH,
        render: (renderProps: any) => <MandantView {...renderProps} />,
        createBreadcrumbs: () => [<MandantBreadcrumb />],
    },
    {
        exact: true,
        path: MANDANTPATH,
        parentPath: MANDANTPATH,
        render: (renderProps: any) => <MandantDetailsView {...renderProps} />,
        createBreadcrumbs: () => [<MandantBreadcrumb />],
    },
    {
        exact: true,
        path: "/mandant/firmendaten",
        parentPath: MANDANTPATH,
        render: (renderProps: any) => <FirmendatenDetailsView {...renderProps} />,
        createBreadcrumbs: () => [<MandantBreadcrumb />, <MandantFirmendatenBreadcrumb />],
    },
    {
        exact: true,
        path: "/mandant/abgleichseinstellungen",
        parentPath: MANDANTPATH,
        render: (renderProps: any) => <MandantAbgleichDetailsView {...renderProps} />,
        createBreadcrumbs: () => [<MandantBreadcrumb />, <MandantAbgleichDetailsBreadcrumb />],
    },
    {
        exact: true,
        path: "/mandant/kontoadresse",
        parentPath: MANDANTPATH,
        render: (renderProps: any) => <KontoAdressenDetailsView {...renderProps} />,
        createBreadcrumbs: () => [<MandantBreadcrumb />, <KontoAdresseBreadcrumb />],
    },
    {
        path: "/supportmandanten",
        render: (renderProps: any) => <SupportMandantenView {...renderProps} />,
        createBreadcrumbs: () => [<SupportMandantenBreadcrumb />],
    },
    {
        path: SUPPORTMANDANTPATH,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <SupportMandantView {...renderProps} />}
                left={() => <SupportMandantenNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <SupportMandantenBreadcrumb />,
            <SupportMandantBreadcrumb mandantId={createProps.mandantId} />,
        ],
    },
    {
        exact: true,
        path: SUPPORTMANDANTPATH,
        parentPath: SUPPORTMANDANTPATH,
        render: (renderProps: any) => <SupportMandantDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SupportMandantenBreadcrumb />,
            <SupportMandantBreadcrumb mandantId={createProps.mandantId} />,
        ],
    },
    {
        exact: true,
        path: "/supportmandant/:mandantId/firmendaten",
        parentPath: SUPPORTMANDANTPATH,
        render: (renderProps: any) => <SupportMandantFirmendatenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SupportMandantenBreadcrumb />,
            <SupportMandantBreadcrumb mandantId={createProps.mandantId} />,
            <SupportMandantFirmendatenBreadcrumb mandantId={createProps.mandantId} />,
        ],
    },
    {
        exact: true,
        path: "/supportmandant/:mandantId/provisionsdaten",
        parentPath: SUPPORTMANDANTPATH,
        render: (renderProps: any) => <SupportMandantProvisionsdatenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SupportMandantenBreadcrumb />,
            <SupportMandantBreadcrumb mandantId={createProps.mandantId} />,
            <SupportMandantProvisionsdatenBreadcrumb mandantId={createProps.mandantId} />,
        ],
    },
    {
        exact: true,
        path: "/supportmandant/:mandantId/datenschutzeinstellungen",
        parentPath: SUPPORTMANDANTPATH,
        render: (renderProps: any) => <SupportMandantDatenschutzeinstellungenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SupportMandantenBreadcrumb />,
            <SupportMandantBreadcrumb mandantId={createProps.mandantId} />,
            <SupportMandantDatenschutzeinstellungenBreadcrumb mandantId={createProps.mandantId} />,
        ],
    },
    {
        exact: true,
        path: "/supportmandant/:mandantId/konten",
        parentPath: SUPPORTMANDANTPATH,
        render: (renderProps: any) => <SupportKontoMandantenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SupportMandantenBreadcrumb />,
            <SupportMandantBreadcrumb mandantId={createProps.mandantId} />,
            <SupportMandantKontenBreadcrumb mandantId={createProps.mandantId} />,
        ],
    },
    {
        exact: true,
        path: "/testzugang",
        render: (renderProps: any) => <TestzugangRedirect {...renderProps} />,
        unauthorized: true,
        createBreadcrumbs: () => []
    },
    {
        exact: true,
        path: "/aushang",
        render: (renderProps: any) => <DigitalerAushangView {...renderProps} />,
        unauthorized: true,
        createBreadcrumbs: () => [],
        hideHeader: true,
    },
    {
        exact: true,
        path: "/aendereemail/:userId/:neueEMail/:token",
        render: (renderProps: any) => <BestaetigeEMailAenderungDialog {...renderProps} />,
        unauthorized: true,
        createBreadcrumbs: () => []
    },
    {
        exact: true,
        path: "/bestaetigeemail/:eMail/:token",
        render: (renderProps: any) => <BestaetigeEMailDialog {...renderProps} />,
        unauthorized: true,
        createBreadcrumbs: () => []
    },
    // Die drei folgenden Routen (/support, /termsofuse, /privacypolicy) werden für Zoom benötigt
    {
        exact: true,
        path: "/support",
        render: (renderProps: any) => <SupportRedirect {...renderProps} />,
        unauthorized: true,
        createBreadcrumbs: () => []
    },
    {
        exact: true,
        path: "/termsofuse",
        render: (renderProps: any) => <AgbRedirect {...renderProps} />,
        unauthorized: true,
        createBreadcrumbs: () => []
    },
    {
        exact: true,
        path: "/privacypolicy",
        render: (renderProps: any) => <DatenschutzRedirect {...renderProps} />,
        unauthorized: true,
        createBreadcrumbs: () => []
    },
    {
        path: "/mitteilungen",
        render: (renderProps: any) => <MitteilungenView {...renderProps} />,
        createBreadcrumbs: () => [<MitteilungenBreadcrumb />],
    },
    {
        path: "/mandantBelege",
        render: (renderProps: any) => <MandantBelegeView {...renderProps} />,
        createBreadcrumbs: () => [<MandantBelegeBreadcrumb />],
    },
    {
        path: "/mandantBeleg/:belegart/:belegId",
        render: (renderProps: any) => (
            <VerticalSplit
                left={() => <MandantBelegeNavigationView {...renderProps} />}
                right={() => <MandantBelegView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <MandantBelegeBreadcrumb />,
            <MandantBelegBreadcrumb belegart={createProps.belegart} belegId={createProps.belegId} />],
    },
    {
        exact: true,
        path: "/mandantBeleg/:belegart/:belegId",
        parentPath: "/mandantBeleg/:belegart/:belegId",
        render: (renderProps: any) => <MandantBelegDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <MandantBelegeBreadcrumb />,
            <MandantBelegBreadcrumb belegart={createProps.belegart} belegId={createProps.belegId} />],
    },
    {
        exact: true,
        path: "/mandantBeleg/:belegart/:belegId/provisionen",
        parentPath: "/mandantBeleg/:belegart/:belegId",
        render: (renderProps: any) => <MandantBelegProvisionenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <MandantBelegeBreadcrumb />,
            <MandantBelegBreadcrumb belegart={createProps.belegart} belegId={createProps.belegId} />,
            <MandantBelegProvisionenBreadcrumb belegart={createProps.belegart} belegId={createProps.belegId} />],
    },
];
